import React from 'react'
import { PoseGroup } from 'react-pose'
import { useToggle } from '../../hooks'
import Icon from '../../components/Icon'
import Container from '../../components/Container'
import { SortStyled, SortItem, SortItems, SortButton, Title, StyledIcon } from './styled'

const Sort = React.memo(({ sortOrder, setSortOrder, sortItems, translation }) => {
    const [isOpen, toggleIsOpen] = useToggle(false)

    const handleClickSortItem = item => () => {
        setSortOrder(item)
        toggleIsOpen()
        // setTimeout(() => {
        //     toggleIsOpen()
        // }, 150)
    }

    return (
        <SortStyled>
            <SortButton onClick={toggleIsOpen}>
                {isOpen ? translation ? translation['order-close'] : '' : <Icon name={(sortOrder && sortOrder.direct === 'asc') ? 'sort_asc' : 'sort_desc'} />}
            </SortButton>
            <PoseGroup>
                {isOpen &&
                    <SortItems
                        key="search"
                    >
                        <Container>
                            <Title>{translation && translation['order-title']}</Title>
                            {
                                sortItems.map((item , index) => {
                                    const active = sortOrder.key === item.key
                                    return (
                                        <SortItem
                                            key={item.key || index}
                                            onClick={handleClickSortItem(item)}
                                            active={active}
                                        >
                                            <StyledIcon name={active ? sortOrder.direct === 'asc' ? 'sort_asc' : 'sort_desc' : item.direct === 'asc' ? 'sort_asc' : 'sort_desc'} active={active} /> {item.txt}
                                        </SortItem>
                                    )
                                })
                            }
                        </Container>
                    </SortItems>
                }
            </PoseGroup>
        </SortStyled>
    )
})

export default Sort
